import { reaction } from 'mobx';
import { createObservableInstance } from '../../helpers';
import PropertyState from '../shared/PropertyState';
import TenancyState from '../shared/TenancyState';

class TenantTenancyState extends TenancyState {
  init() {
    super.init();

    this.reactions_.push(
      reaction(
        () => this.data?.propertyUid,
        (v) => this.handleValue(v)
      )
    );
  }

  get isInitialized() {
    return super.isInitialized && this.property.isInitialized;
  }

  handleValue(v) {
    this.property?.destroy();
    this.property = null;
    if (v) {
      this.property = createObservableInstance(PropertyState, this, v);
    }
  }

  destroy() {
    super.destroy();

    this.property?.destroy();
  }
}

TenantTenancyState.annotations = {
  ...TenancyState.annotations,
};

export default TenantTenancyState;
